require('../../../modules/es.string.substr');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('String').substr;
